/**
 * Order Entry - Interface Control Enum
 * This enumeration contains identifiers for all components that comprize the order entry interface,
 */
export enum OENInputControl {
  // CLIENT
  CLIENT, // BfxAutocompleteInputComponent
  ACCOUNT, // BfxAutocompleteInputComponent
  CONTACT, // BfxContactsInputComponent
  TRADER, // BfxAutocompleteInputComponent
  CLIENT_ACTIVE_TAB,
  ACCOUNT_ACTIVE_TAB,
  // FINANCIALS
  CCY_PAIR, // BfxCcyPairInputComponent
  ORDER_TYPE, // BfxAutocompleteInputComponent
  CLIENT_INTENT, // BfxClientIntentToggleComponent
  FIXED_CCY, // BfxFixedCcyToggleComponent
  ORDER_AMOUNT, // BfxAmountSpinnerComponent
  REQUEST_PRICE, // BfxPriceSpinnerComponent
  VALUE_DATE, // BfxValueDateComponent
  TRIGGER,
  GOOD_FROM,
  GOOD_UNTIL,
  SUSPEND, // BfxOrderEntrySuspendModel // container for suspend from and to
  SUSPEND_FROM, // BfxOrderEntryTimeControlModel
  SUSPEND_TO, // BfxOrderEntryTimeControlModel
  MARKUP,
  MARKUP_TYPE,
  TRADER_GROUP,
  ALGO_TYPE, // algos only // ICAlgoType => ICAutocompleteGenericModel
  LIMIT_PRICE, // algos only // ICLimitPrice => ICLimitPriceModel
  FIXING_SOURCE,
  FIXING_DATE,
  // MORE
  CLIENT_COMMENTS, // string
  PRIVATE_COMMENTS, // string
  HOLD_STP, // boolean
  AUTO_FORWARD_PRICING, // boolean
  EXECUTION_MODE,
  PRIVATE_ORDER,
  PARTIAL_FILL,
  STP_AGG,
  // notification panel
  BTN_OCO,
  BTN_IF_DONE,
  BTN_LOOP,
  BTN_TIMEOUT,
  // wildcard for multiple elements
  _MULTI_,
  // wildcard for algo control
  _ALGO_,
  FIXING_TIME,
  FIXING_TIMEZONE,
  // obo fields
  OBO_CLIENT,
  OBO_ACCOUNT,
  // Gamma fields
  DELTA,
  RUNGS_ABOVE,
  RUNGS_BELOW,
  CUSTOM_FIELDS,
  // Multi Allocation fields
  ALLOCATIONS,
  // TSL fields
  TRAILING_PIPS,
  TRAILING_TRIGGER,
}
